import React from 'react'
import styles from './Pagination.module.scss'

const Pagination = ({ currentPage, totalPages, onPageChange, maxVisiblePages = 7 }) => {
  if (totalPages <= 1) return null

  const getVisiblePages = () => {
    const halfVisible = Math.floor(maxVisiblePages / 2)
    let startPage = Math.max(1, currentPage - halfVisible)
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1)
    
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1)
    }
    
    const pages = []
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i)
    }
    
    return pages
  }

  const visiblePages = getVisiblePages()
  const showLeftEllipsis = visiblePages[0] > 2
  const showRightEllipsis = visiblePages[visiblePages.length - 1] < totalPages - 1

  return (
    <div className={styles.pagination}>
      <button
        className={`${styles.pageButton} ${styles.navButton}`}
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        ← Предыдущая
      </button>

      <div className={styles.pageNumbers}>
        {visiblePages[0] > 1 && (
          <button
            className={styles.pageButton}
            onClick={() => onPageChange(1)}
          >
            1
          </button>
        )}

        {showLeftEllipsis && (
          <span className={styles.ellipsis}>...</span>
        )}

        {visiblePages.map(page => (
          <button
            key={page}
            className={`${styles.pageButton} ${currentPage === page ? styles.active : ''}`}
            onClick={() => onPageChange(page)}
          >
            {page}
          </button>
        ))}

        {showRightEllipsis && (
          <span className={styles.ellipsis}>...</span>
        )}

        {visiblePages[visiblePages.length - 1] < totalPages && (
          <button
            className={styles.pageButton}
            onClick={() => onPageChange(totalPages)}
          >
            {totalPages}
          </button>
        )}
      </div>

      <button
        className={`${styles.pageButton} ${styles.navButton}`}
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        Следующая →
      </button>

      <div className={styles.pageInfo}>
        Страница {currentPage} из {totalPages}
      </div>
    </div>
  )
}

export default Pagination